import { Component, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-list-toolbar',
  standalone: true,
  imports: [FormsModule, LucideAngularModule],
  template: `
    <div class="flex flex-wrap items-center gap-2 py-2">
      <!-- Chips -->
      <button
        type="button"
        (click)="statusClick.emit()"
        class="inline-flex items-center gap-1.5 h-8 px-3 rounded-[var(--r-sm)] text-sm font-medium text-[var(--text)] bg-[var(--bg-surface)] border border-[var(--border)] hover:bg-[var(--hover)] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)]"
      >
        <lucide-icon name="settings" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
        Status
      </button>
      <button
        type="button"
        (click)="camposClick.emit()"
        class="inline-flex items-center gap-1.5 h-8 px-3 rounded-[var(--r-sm)] text-sm font-medium text-[var(--text)] bg-[var(--bg-surface)] border border-[var(--border)] hover:bg-[var(--hover)] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)]"
      >
        <lucide-icon name="columns-3" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
        Campos
      </button>

      <div class="flex-1 min-w-[200px] max-w-sm">
        <div class="relative">
          <lucide-icon
            name="search"
            class="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--muted)] pointer-events-none"
          ></lucide-icon>
          <input
            type="search"
            [ngModel]="searchQuery()"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Buscar nesta lista"
            class="w-full h-8 pl-8 pr-3 rounded-[var(--r-sm)] text-sm border border-[var(--border)] bg-[var(--bg-surface)] text-[var(--text)] placeholder:text-[var(--faint)] focus:outline-none focus:ring-2 focus:ring-[var(--focus)] focus:border-transparent"
          />
        </div>
      </div>

      <button
        type="button"
        (click)="filterClick.emit()"
        class="h-8 w-8 rounded-[var(--r-sm)] flex items-center justify-center text-[var(--muted)] hover:bg-[var(--hover)] hover:text-[var(--text)] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)]"
        title="Filtros"
      >
        <lucide-icon name="sliders-horizontal" class="h-4 w-4"></lucide-icon>
      </button>
    </div>
  `,
})
export class ListToolbarComponent {
  searchQuery = signal('');
  statusClick = output<void>();
  camposClick = output<void>();
  filterClick = output<void>();
  searchChange = output<string>();

  onSearchChange(value: string): void {
    this.searchQuery.set(value);
    this.searchChange.emit(value);
  }
}
